module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074a5_logo_200x200.d10d4a5b.png";